export const NAVER = {
  CLIENT_ID: process.env.REACT_APP_NAVER_CLIENT_ID,
  CALLBACK_URL: process.env.REACT_APP_REDBRICK_SSO_REDIRECT + "/redirect",
  CALLBACK_URL_STUDIO: process.env.REACT_APP_REDBRICK_SSO_REDIRECT + "/redirect",
};

export const GOOGLE = {
  CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID,
};

export const KAKAO = {
  CLIENT_ID: process.env.REACT_APP_KAKAO_CLIENT_ID,
  REDIRECT_URI: process.env.REACT_APP_REDBRICK_SSO_REDIRECT,
  REDIRECT_URI_STUDIO: process.env.REACT_APP_REDBRICK_SSO_REDIRECT + "/redirect",
  JS_KEY: process.env.REACT_APP_KAKAO_JS_KEY,
};

export const FACEBOOK = {
  CLIENT_ID: process.env.REACT_APP_FACEBOOK_CLIENT_ID,
};

export const MICROSOFT = {
  CLIENT_ID: process.env.REACT_APP_MICROSOFT_CLIENT_ID,
  AUTHORITY: process.env.REACT_APP_MICROSOFT_AUTHORITY,
  REDIRECT_URL: process.env.REACT_APP_REDBRICK_SSO_REDIRECT,
  GRAPHME_ENDPOINT: process.env.REACT_APP_GRAPHME_ENDPOINT,
};

export const SNS = {
  REDBRICK: null,
  METAMASK: "METAMASK",
  NAVER: "NAVER",
  KAKAO: "KAKAO",
  FACEBOOK: "FACEBOOK",
  GOOGLE: "GOOGLE",
  OTHER: "OTHER",
  MICROSOFT: "MICROSOFT",
};

export const SNS_CALL = {
  LOGIN: "LOGIN",
  CONNECT: "CONNECT",
};

export const STATUS = {
  NEED_TO_SIGN_UP: "NEED_TO_SIGN_UP",
  SAME_ACC_EXIST: "SAME_ACC_EXIST",
  ALREADY_ACC_CONNECTED: "ALREADY_ACC_CONNECTED",
  LOGIN_SUCCEED: "LOGIN_SUCCEED",
  LINK_ERROR: "LINK_ERROR",
  LINK_SUCCESS: "LINK_SUCCESS",
  LOGIN_ERROR: "LOGIN_ERROR",
  EMAIL_NOT_EXIST: "EMAIL_NOT_EXIST",
  CANNOT_DISCONNECT: "CANNOT_DISCONNECT",
};

export const SNS_RES = {
  [SNS_CALL.LOGIN]: {
    1: STATUS.LOGIN_SUCCEED,
    804: STATUS.SAME_ACC_EXIST,
    805: STATUS.NEED_TO_SIGN_UP,
  },
  [SNS_CALL.CONNECT]: {
    1: STATUS.LINK_SUCCESS,
    806: STATUS.LINK_ERROR,
    808: STATUS.ALREADY_ACC_CONNECTED,
  },
};
